<div class="profile"
     [class.profile--opened]="isOpened"
     (mouseover)="isOpened=true"
     (mouseout)="isOpened=false">
  <div class="profile__avatar">
    <img *ngIf="avatar" [src]="avatar" alt=""/>
    <div *ngIf="!avatar">{{ name? name[0]:'T' }}</div>
  </div>
  <mat-icon class="profile__icon">arrow_drop_down</mat-icon>

  <div class="profile__menu mat-elevation-z4" [class.opened]="isOpened">
    <a mat-button
       class="profile__menu--admin"
       routerLink="/admin">Admin panel</a>
    <a mat-button
       class="profile__menu--logout"
       (click)="logout()">
      Logout
    </a>
  </div>
</div>
